import { render, staticRenderFns } from "./LecturePattern.vue?vue&type=template&id=15526d44"
import script from "./LecturePattern.vue?vue&type=script&lang=js"
export * from "./LecturePattern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports